import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

function loadOptionalScripts() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "consent_granted" });

  const analytics = document.createElement("script");
  analytics.async = true;
  analytics.src = "https://www.googletagmanager.com/gtag/js?id=G-5ZWKWMJGH2";
  document.head.appendChild(analytics);

  window.setTimeout(() => {
    const chat = document.createElement("script");
    chat.async = true;
    chat.src = "https://embed.tawk.to/6935e396b2d7c11987b69679/1jbt820ut";
    chat.crossOrigin = "anonymous";
    document.body.appendChild(chat);
  }, 3_000);
}

export default function ConsentBanner() {
  const [choice, setChoice] = useState<string | null>(() =>
    localStorage.getItem("heartnest-cookie-consent")
  );

  useEffect(() => {
    if (choice === "accepted") loadOptionalScripts();
  }, [choice]);

  const choose = (value: "accepted" | "essential") => {
    localStorage.setItem("heartnest-cookie-consent", value);
    setChoice(value);
  };

  if (choice) return null;

  return (
    <aside
      className="fixed inset-x-4 bottom-4 z-[100] mx-auto max-w-3xl rounded-2xl border bg-background p-5 shadow-2xl"
      aria-label="Cookie preferences"
    >
      <p className="font-semibold">Your privacy choices</p>
      <p className="mt-1 text-sm text-muted-foreground">
        Essential storage keeps the site working. With your permission, analytics and live chat help us improve support. See our{" "}
        <Link className="underline" to="/cookies">cookie policy</Link>.
      </p>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:justify-end">
        <Button variant="outline" onClick={() => choose("essential")}>Essential only</Button>
        <Button onClick={() => choose("accepted")}>Accept optional cookies</Button>
      </div>
    </aside>
  );
}
